/**
 * <gh-title-fit> — keeps the product page / quick view design name within `data-max-lines`
 * lines (blocks/gh-product-title.liquid). CSS already sizes it from its length; this measures
 * the rendered name and scales the whole title down (--gh-fit, the line on top follows) until it
 * fits, never below `data-min-size` px. Runs when inserted (also inside the quick view), when
 * fonts load and when the title's width changes.
 */
class GhTitleFit extends HTMLElement {
  connectedCallback() {
    this.titleEl = this.querySelector('.gh-product-title');
    this.nameEl = this.querySelector('.gh-product-title__name');
    if (!this.titleEl || !this.nameEl) return;

    this.width = 0;
    this.fit = this.fit.bind(this);
    this.resizeObserver = new ResizeObserver((entries) => {
      const width = Math.round(entries[0].contentRect.width);
      if (width === this.width) return; // only width changes; fitting changes the height
      this.width = width;
      this.fit();
    });
    this.resizeObserver.observe(this);
    document.fonts?.ready.then(this.fit);
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
  }

  lines() {
    const lineHeight = parseFloat(getComputedStyle(this.nameEl).lineHeight);
    return Math.round(this.nameEl.getBoundingClientRect().height / lineHeight);
  }

  fit() {
    if (!this.nameEl.isConnected) return;
    const maxLines = Number(this.dataset.maxLines) || 2;
    const minSize = Number(this.dataset.minSize) || 28;
    let scale = 1;
    this.titleEl.style.setProperty('--gh-fit', '1');
    for (let i = 0; i < 24 && this.lines() > maxLines; i++) {
      if (parseFloat(getComputedStyle(this.nameEl).fontSize) <= minSize) break;
      scale *= 0.94;
      this.titleEl.style.setProperty('--gh-fit', scale.toFixed(3));
    }
  }
}

if (!customElements.get('gh-title-fit')) customElements.define('gh-title-fit', GhTitleFit);
